import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Contact.requests'

import {
    Contact,
} from '../Contacts.types'

const useUpdateContact = ({
    onSuccess,
}: { onSuccess: (...args: any[]) => void }) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessUpdateCompany,
        onError,
    } = useHandleStatusRequest({
        title: 'Contact was updated',
        id: 'ContactUpdated',
        onSuccess,
    })

    const {
        mutate,
    } = useMutation({
        mutationFn: (contact: Contact) => {
            return simpleApi({
                ...requests.update({
                    data: contact,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessUpdateCompany,
    })

    return mutate
}

export default useUpdateContact
